/**
 * Register the Solar icon set locally so @iconify/react never fetches
 * from api.iconify.design at runtime (avoids CSP violations).
 *
 * Import this module in any component that uses Solar icons via <Icon />.
 */
import { addCollection } from '@iconify/react';
import solarIcons from '@iconify-json/solar/icons.json';

addCollection(solarIcons as Parameters<typeof addCollection>[0]);
